// Component: LinkCard
// Author: Tejaswini
import * as React from 'react';
import LinkCardUI from '@component/LinkCard';
import { Text, withSitecoreContext, RichText } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import WBRString from '@component/WbrString';

const LinkCard = (props) => {
  const links = [];

  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;

  props.fields?.children?.forEach((link, index) => {
    let l = (
      <>
        <RoutableLink field={link.fields?.Link} key={index} useATag={true}>
          <WBRString tag="span">
            <Text field={link.fields?.LinkText} />
          </WBRString>
        </RoutableLink>
        <EditableLink linkField={link.fields?.Link} isEditing={isEditing} />
      </>
    );

    links.push(l);
  });
  var LinkCardData = {
    title: <Text field={props.fields?.Title} />,
    description: <RichText field={props.fields?.Description} />,
    links: links,
  };
  return (
    <>
      <LinkCardUI {...LinkCardData} />
    </>
  );
};
export default LinkCard;
